// Create: Redux/Reducers/OrderReducer.js
import * as Types from '../Constants/AllConstants';

// Get all orders (paged)
export const GetAllOrdersReducer = (
  state = { orders: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.ORDERS_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.ORDERS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
        totalElements: action.payload.totalElements,
      };
    case Types.ORDERS_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.ORDERS_LIST_RESET:
      return { orders: [], pages: 0, page: 0 };
    default:
      return state;
  }
};

// Get order details
export const OrderDetailsReducer = (state = { order: null }, action) => {
  switch (action.type) {
    case Types.ORDER_DETAILS_REQUEST:
      return { loading: true };
    case Types.ORDER_DETAILS_SUCCESS:
      return { loading: false, order: action.payload };
    case Types.ORDER_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case Types.ORDER_DETAILS_RESET:
      return { order: null };
    default:
      return state;
  }
};

// Get order items
export const OrderItemsReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case Types.ORDER_ITEMS_REQUEST:
      return { loading: true };
    case Types.ORDER_ITEMS_SUCCESS:
      return { loading: false, items: action.payload };
    case Types.ORDER_ITEMS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get order stats/dashboard metrics
export const OrderStatsReducer = (state = { stats: null }, action) => {
  switch (action.type) {
    case Types.ORDER_STATS_REQUEST:
      return { ...state, loading: true };
    case Types.ORDER_STATS_SUCCESS:
      return { loading: false, stats: action.payload };
    case Types.ORDER_STATS_FAIL:
      return { loading: false, error: action.payload };
    case Types.ORDER_STATS_RESET:
      return { stats: null };
    default:
      return state;
  }
};

// Complete order
export const CompleteOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.ORDER_COMPLETE_REQUEST:
      return { loading: true };
    case Types.ORDER_COMPLETE_SUCCESS:
      return { loading: false, success: true, order: action.payload };
    case Types.ORDER_COMPLETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.ORDER_COMPLETE_RESET:
      return {};
    default:
      return state;
  }
};

// Get user orders
export const UserOrdersReducer = (
  state = { orders: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.USER_ORDERS_REQUEST:
      return { ...state, loading: true };
    case Types.USER_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.content || action.payload,
        pages: action.payload.totalPages || 0,
        page: action.payload.number || 0,
      };
    case Types.USER_ORDERS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};